import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Hero } from './components/Hero';
import { MaterialPreview } from './components/MaterialPreview';
import { PainPoints } from './components/PainPoints';
import { Volumes } from './components/Volumes';
import { Bonuses } from './components/Bonuses';
import { Testimonials } from './components/Testimonials';
import { Pricing } from './components/Pricing';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { ClosingCta } from './components/ClosingCta';
import { CostComparison } from './components/CostComparison';
import { FloatingNotification } from './components/FloatingNotification';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="leaf-canvas min-h-screen w-full text-brand-text font-sans selection:bg-brand-greenLight/40 selection:text-brand-purpleDark" data-id="element-0" data-mp="23vktwcepa1j4">
      <UrgencyBanner data-id="element-1" data-mp="3ijfv1zlojwem" />
      <main data-id="element-2" data-mp="3ihuyk4ft23e4">
        <Hero data-id="element-3" data-mp="3mljaezbgzl56" />
        <MaterialPreview data-id="element-4" data-mp="3ml14tc2x3ukl" />
        <PainPoints data-id="element-5" data-mp="3mkhou0wtvg97" />
        <Volumes data-id="element-6" data-mp="3mjq1tehaqquj" />
        <Bonuses data-id="element-7" data-mp="3mj6ipufwtwex" />
        <Testimonials data-id="element-8" data-mp="3rcj5s04xxv5k" />
        <Pricing data-id="element-9" data-mp="3rbznujfaj6rj" />
        <Guarantee data-id="element-10" data-mp="3rdkh85pvcjnt" />
        <FAQ data-id="element-11" data-mp="3rd189ei755lx" />
        <CostComparison data-id="element-12" data-mp="3relvej26lm9r" />
        <ClosingCta data-id="element-13" data-mp="6hqffdy0fe4" />
      </main>
      <Footer data-id="element-14" data-mp="4n6o4eeqtbm" />
      <FloatingNotification data-id="element-15" data-mp="56n1goet9nj" />
    </div>;
}